<template>
  <v-dialog v-model="dialogEditShow" max-width="1424px" persistent>
    <v-card class="pa-4 pa-sm-8 test-editor">
      <h4 class="mb-5">Домены для опросника {{ instrument.title }}</h4>
      <v-btn class="button-close ma-4" icon @click="dialogEditShow=false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <!-- {{domains}} -->
      <div class="items-list-wrapper">
        <transition-group class="items-list w-100" name="list-complete" tag="div">
          <div v-if="!domains || !domains.length" class="mb-4" :key="-1">Добавьте домены</div>
          <div class="row row-complete-item item-question" v-for="domain in domains" :key="domain.id">
            <div class="col-3 pb-0 pt-6">
              <v-text-field label="Название домена" dense class="mt-2" v-model="domain.title" @input="debouncedDomainChanged(domain)" />
              <v-btn class="mr-3" color="primary" @click="editIntervals(domain)"> Редактировать интервалы </v-btn>
            </div>
            <div class="col-9 d-flex align-center pt-0 pb-4">
              <html-content-editor v-model="domain.description" :update="forceUpdate" @input="debouncedDomainChanged(domain)" title="Описание:" class="w-100 mr-1" />
              <v-btn icon color="error" @click="askDelete(domain)"><v-icon>mdi-delete-outline</v-icon></v-btn>
            </div>
          </div>
          <div class="row row-complete-item" :key="-2">
            <v-btn class="add-button" fab dark small color="primary" @click="addItem()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </transition-group>
      </div>

      <div class="row mt-3 justify-end">
        <v-btn class="mr-3" @click="dialogEditShow=false"> Закрыть </v-btn>
      </div>
    </v-card>
    <AskDialog v-model="showAskDeleteDialog" @ok="delItem(curDomain)" />
    <EditDomainIntervalsDialog v-model="showIntervalsDialog" :domain="curDomain" />
  </v-dialog>
</template>

<script>
/*eslint-disable*/
import { mapActions, mapState, mapGetters } from 'vuex';
import { debounce, cloneDeep } from 'lodash';
import AskDialog from "@/components/ui/AskDialog"
import HtmlContentEditor from '@/components/testEditor/htmlEditor/HtmlContentEditor.vue';
import EditDomainIntervalsDialog from '@/components/testEditor/domains/EditDomainIntervalsDialog.vue';

export default {
  name: 'EditDomainsDialog',
  components: {
    AskDialog, HtmlContentEditor, EditDomainIntervalsDialog
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: Boolean,
    instrument: Object,
  },
  data: () => ({
    domains: [],
    showAskDeleteDialog: false,
    showIntervalsDialog: false,
    curDomain: null,
    saving: false,
    forceUpdate: false,
  }),
  watch: {
    async dialogEditShow(newVal) {
      if (newVal) {
        this.domains = cloneDeep(this.allDomains.filter(d => d.instrument === this.instrument.id))
        this.forceUpdate = !this.forceUpdate
      } else {
        // await this.loadDomains()
        this.domains = [] 
      }
    }
  },
  computed: {
    dialogEditShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', false);
      }
    },
    ...mapGetters({
      loading: 'testEditor/domains/loading',
      allDomains: 'testEditor/domains/domains',
    }),

  },

  methods: {
    ...mapActions({
      saveDomain: 'testEditor/domains/saveDomain',
      addDomain: 'testEditor/domains/addDomain',
      delDomain: 'testEditor/domains/delDomain',
      loadDomains: 'testEditor/domains/loadDomains',
    }),
    debouncedDomainChanged: debounce(function (domain) {
      this.saveDomain(domain);
    }, 500),
    editIntervals(domain) {
      this.curDomain = domain
      this.showIntervalsDialog = true
    },
    async addItem() {
      const newDomain = {
        instrument: this.instrument.id,
        description: "Описание " + (this.domains.length+1),
        title: 'Домен '+ (this.domains.length+1),
      }
      const response = await this.addDomain(newDomain)
      console.log('response', response)
      this.domains.push(response)
    },
    askDelete(domain) {
      this.curDomain = domain
      this.showAskDeleteDialog = true
    },

    async delItem(domain) {
      const response = await this.delDomain(domain)
      if (response) {
        const ind = this.domains.findIndex(el => el.id === domain.id)
        if (ind>=0) 
          this.domains.splice(ind, 1);
      }
    },

  }
};
</script>

<style scoped>

</style>